module.exports = __webpack_public_path__ + "eventItemImg.b41ff00e.png";